export const UIS_CONTAINER_TAG_NAME = 'uis-container';
